const TypeOcurrences = {
  ADDRESS: "address",
  SPECIALITY: "speciality",
  OCUCPATION_AREA: "occupationArea",
};

export default TypeOcurrences;
